<script>

import Utils from '../../../common/Utils';
import CommonConstants from '../../../common/Constants';
import Service from '@/services/planning';
import ResponsiveButton from '../../../components/generic/ResponsiveButton.vue'
//import { FilterMatchMode, FilterOperator } from 'primevue/api'
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default {
    components: 
        {
            GenericCustomMasterDataAutocompleteV2,
            ResponsiveButton
        },
    props: [],
    data() {
        return {                            
            settle: [],
            settleDailyPrice: [],
            editSettle: [],
            editSettleDailyPrice: [],
            selectedSettleItem: null,
            selectedSettle: {},
            showSettleDialog: false,
            showSettleDailyPriceDialog: false,
            addSettle: {},
            addSettleDailyPrice: {},
            startDate : Utils.setFirstDayOfMonth(Utils.formatDatePlusMonths(new Date(), -2)),
            options: [
                {
                    label: this.$t('yes'),
                    value: true
                },
                {
                    label: this.$t('no'),
                    value: false
                }
            ],
            importParams: {
                dateFrom: null,
                dateTo: null,
                poolName: null
            },
            importDialogVisible: false
        }
    },
    created() {
        this.$store.dispatch('security/setNavbarTitle', 'Settle.page_title');
        this.loadSettle();
    },
    mounted() {
        let cacheFilters = null;
        let cacheData = this.$store.getters['cacheDataStore/getGridCache']('SettleGrid');
        if(cacheData){
            cacheFilters = {};
            for(let i = 0; i < cacheData.length; i++){
                let element = cacheData[i];
                cacheFilters[element.property] = element;
                // let k = element.property.charAt(0).toLowerCase() + element.property.slice(1);
                this.filters[element.propName] = element.value;
            }
            if(cacheFilters){
                this.loadSettle();
            }
        }    
    },
    computed: {
        constants() {
            return CommonConstants; 
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    },
    methods: {
        loadSettle(){
            let body = {
                startDate: this.startDate,
            }

            let filters = [
                {
                operator: '=',
                    value: Utils.formatDateForAPI(this.startDate),
                    property: 'MonthStartDate'
                }
            ];
            let params = {
                filter: JSON.stringify(filters),
            }

            let cacheData = {
                name: 'SettleGrid',
                filters: body
            };

            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
            this.$store.dispatch("generic/setLoading", true);
            Service.getSettle(params, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.settle = response.data;
                    for(let i = 0; i < this.settle.length; i++)
                    {
                        let item = this.settle[i];
                        item.monthStartDate = item.monthStartDate ? Utils.dateToCurrentTimeZone(item.monthStartDate) : null;
                    }
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        loadDetails(headerId){
            let filters = [
                {
                    operator: 'eq',
                    value: headerId,
                    property: 'IdPlanningTrueUpSettle'
                }
            ];
            let params = {
                filter: JSON.stringify(filters),
            }

            Service.getSettleDailyPrice(params, response => {
                if(response.success){
                    this.settleDailyPrice = response.data;
                    for(let i = 0; i < this.settleDailyPrice.length; i++)
                    {
                        let item = this.settleDailyPrice[i];
                        item.settleDate = item.settleDate ? Utils.dateToCurrentTimeZone(item.settleDate) : null;
                    }
                }else{
                this.settleDailyPrice = [];
                }
            })
        },
        onSettleRowEditSave(data){
            console.log(data.newData)
            this.$store.dispatch("generic/setLoading", true);
            Service.updateSettle(data.newData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.loadSettle();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onSettleDailyPriceRowEditSave(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updateSettleDailyPrice(data.newData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.loadDetails(this.selectedSettle.id);
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onHeaderSelect(e){
            this.loadDetails(e.data.id);
        },
        submitSettleHeader(){

        },
        openDialogSettleDailyPrice(){
            this.addSettleDailyPrice = {
                idPlanningTrueUpSettle: this.selectedSettle.id
            };
            console.log(this.addSettleDailyPrice);
            this.showSettleDailyPriceDialog = true;
        },
        submitSettleDailyPrice(){
            Service.addSettleDailyPrice(this.addSettleDailyPrice, 
            response => {
              if(response.success){
                this.showPriceFormulaDetailsDialog = false;
                this.loadDetails(this.selectedSettle.id);
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
        },
        deleteSettleDailyPrice(id){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {                  
                    Service.deleteSettleDailyPrice(id, ({success, message}) => {
                        if(success){
                            this.loadDetails(this.selectedSettle.id);
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                        } else{
                            this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    })
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
        },
        onExport(data){
            let body  = {
                idPlanningTrueUpSettle: data.id,
                planningTrueUpFamilyPoolConfiguration: data.planningTrueUpFamilyPoolConfiguration
            };
            this.$store.dispatch("generic/setLoading", true);

            Service.exportSettleDailyPrice(body, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `SettleDailyPrice.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        onImportSettleClick(){
            this.importDialogVisible = true;
        },
        importSettle(){
            /*this.$store.dispatch("generic/setLoading", true);
            Service.importSettle(this.importParams, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.import_message_success'), life: 3000});
                    this.loadSettle();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })*/
            this.$confirm.require({
            message: this.$t('messages.confirm_import'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {                  
                this.$store.dispatch("generic/setLoading", true);
                Service.importSettle(this.importParams, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.import_message_success'), life: 3000});
                        this.importDialogVisible = false;
                        this.loadSettle();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            },
            reject: () => {
                this.$confirm.close();
            }
        });
        }
    },
    beforeRouteLeave(to, from, next) {
      if(this.editSettle.length > 0 || this.editSettleDailyPrice.length > 0){
        this.$confirm.require({
            message: this.$t('Settle.exitMessage'),
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: this.$t('yes'),
            rejectLabel: this.$t('no'),
            accept: () => {
                this.nextRoute = next;
                window.removeEventListener('beforeunload', this.handleBeforeUnload);
                this.nextRoute();
            },
            reject: () => {
                this.$confirm.close();
            }
        });
      }else{
        this.nextRoute = next;
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.nextRoute();
      }
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="importDialogVisible" :style="{ width: '350px' }" modal>
            <div class="grid">
                <div class="col-12 lg:col-6 field">
                    <label for="month">{{$t('from')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="'MM/YYYY'"
                        view="month" dateFormat="mm/yy"
                        :showTime="false"
                        v-model="importParams.dateFrom"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label for="month">{{$t('to')}}</label>
                    <Calendar
                        :class="{'p-inputtext-sm w-full': true}"
                        :placeholder="'dd/mm/yyyy'"
                        :showTime="false"
                        v-model="importParams.dateTo"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label for="week">{{$t('StocchinoPlan.family')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        class="w-full"
                        name="familyPoolConf"
                        v-model="importParams.poolName"
                        api="true-up/family-pool-configuration-combo"/>
                </div>
            </div>
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="importDialogVisible = false"></Button>
                <Button type="button" class="m-2" :label="$t('btn.import')" icon="pi pi-save" @click="importSettle"></Button>
            </div>
        </Dialog> 

        <div class="grid" style="margin-left: 1%">
            <div class="col-12 lg:col-2 md:col-6">
                <label for="startDate">{{ $t('Settle.startDate') }}</label>
                <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.startDate"
                    name="startDate" dateFormat="mm/yy" :showTime="false"
                    view="month" 
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div>
            <!--
            <div class="col-12 lg:col-2 md:col-6">
                <label for="laycanEndDate">{{ $t('dealNote.laycanEndDate') }}</label>
                <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.laycanEndDate"
                    name="laycanEndDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
            </div> -->
            <div class="col-12 lg:col-4 m-2">
                <Button type="button" icon="pi pi-replay" class="mx-1 p-button-sm p-button" :label="$t('Settle.load')" severity="secondary" @click="loadSettle" />
                <Button type="button" icon="pi pi-download" class="mx-1 p-button-sm p-button-success mt-3" :label="$t('btn.import')" severity="secondary" 
                @click="onImportSettleClick" v-if="!uiPermissions('settleImportButton').isHidden" />
                
            </div>         
        </div>

        <div class="col-12 data">
            <div class="grid">
                <div class="col-12">
                    <Card class="col-12" >                
                        <template #content>
                            
                            <Dialog v-model:visible="showSettleDialog" modal class="p-fluid">

                                <div class="field">
                                    <label for="monthStartDate">{{ $t('Settle.startDate') }}</label>
                                    <Calendar 
                                    class="w-full" 
                                    v-model="addSettle.monthStartDate" 
                                    dateFormat="dd/mm/yy" 
                                    placeholder="dd/mm/yyyy"/> 
                                </div>

                                <div class="field">
                                    <label for="isFinal">{{ $t('Settle.isFinal') }}</label>
                                    <Dropdown v-model="addSettle.isFinal" :options="options" optionValue="value" optionLabel="label" />
                                </div>

                                <!--<div class="field">
                                    <label for="planningTrueUpFamilyPoolConfiguration">{{ $t('Settle.planningTrueUpFamilyPoolConfiguration') }}</label>
                                    <GenericCustomMasterDataAutocompleteV2
                                    class="p-inputtext-sm w-full"
                                    v-model="addSettle.idPlanningTrueUpFamilyPoolConfiguration"
                                    api="" 
                                    name=""/> 
                                </div> -->

                                <div class="field">
                                    <label for="averageSettle">{{ $t('Settle.averageSettle') }}</label>
                                    <InputNumber inputId="averageSettle" :minFractionDigits="0" :maxFractionDigits="5" v-model="addSettle.averageSettle" />
                                </div>

                                <template #footer>
                                    <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showSettleDialog = false"/>
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSettleHeader" />
                                </template>
                            </Dialog>

                            <DataTable showGridlines :value="settle" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                            :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editSettle" @row-edit-save="onSettleRowEditSave" 
                            dataKey="id" v-model:selection="selectedSettle" selectionMode="single" @rowSelect="onHeaderSelect" :metaKeySelection="metaKey"
                            paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" class="p-datatable-sm" stripedRows >

                                <template #header>
                                    <Toolbar>
                                        <template #start>
                                            <div class="custom-card-title">{{$t('Settle.page_title')}}</div>
                                        </template>

                                        <!--<template #end>
                                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="showSettleDialog = true"/>
                                        </template> -->
                                    </Toolbar>
                                </template>

                                <Column :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('settleEditButton').isHidden" />
                                <Column class="button-column" :exportable="false" :reorderableColumn="false">
                                    <template #body="slotProps">
                                        <Button icon="pi pi-file" class="p-button-sm p-button-rounded p-button-success mr-1 mb-1" v-tooltip="$t('btn.export')" @click="onExport(slotProps.data)" size="small" />
                                    </template>
                                </Column>
                                <Column field="monthStartDate" :header="$t('Settle.startDate')" >
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                    </template>
                                    <template #editor="{ data, field }">
                                        <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy"/> 
                                    </template>
                                </Column>

                                <Column field="isFinal" :header="$t('Settle.isFinal')" >
                                    <template #body="{ data, field }">
                                        <i class="pi" :class="{ 'pi-check-circle text-green-500': data[field], 'pi-times-circle text-red-500': !data[field] }"></i>
                                    </template>
                                    <template #editor="{ data, field }">
                                        <Dropdown class="w-full" v-model="data[field]" :options="options" optionValue="value" optionLabel="label" />
                                    </template>
                                </Column>

                                <Column field="planningTrueUpFamilyPoolConfiguration" :header="$t('Settle.planningTrueUpFamilyPoolConfiguration')" />

                                <Column field="averageSettle" :header="$t('Settle.averageSettle')" >
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                                    </template>
                                    <template #editor="{ data, field }">
                                        <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="5" v-model="data[field]" />
                                    </template>
                                </Column>

                            </DataTable>
                        </template>                          
                    </Card>
                </div>                            
            </div>
            <div class="grid">
                <div class="col-12">
                    <Card class="col-12" >                
                        <template #content>
                            <Dialog v-model:visible="showSettleDailyPriceDialog" modal class="p-fluid">

                                <div class="field">
                                    <label for="settleDate">{{ $t('SettleDetails.settleDate') }}</label>
                                    <Calendar 
                                    class="w-full" 
                                    v-model="addSettleDailyPrice.settleDate" 
                                    dateFormat="dd/mm/yy" 
                                    placeholder="dd/mm/yyyy"/> 
                                </div>

                                <div class="field">
                                    <label for="settleValue">{{ $t('SettleDetails.settleValue') }}</label>
                                    <InputNumber inputId="settleValue" :minFractionDigits="0" :maxFractionDigits="3" v-model="addSettleDailyPrice.settleValue" />
                                </div>

                                <template #footer>
                                    <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="showSettleDailyPriceDialog = false"/>
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSettleDailyPrice" />
                                </template>
                            </Dialog>
                            <DataTable showGridlines :value="settleDailyPrice" scrollable :responsiveLayout="'stack'" scrollHeight="flex" rowGroupMode="subheader" groupRowsBy="family" sortMode="single"
                            :sortOrder="1" editMode="row" size="small" v-model:editing-rows="editSettleDailyPrice" @row-edit-save="onSettleDailyPriceRowEditSave" 
                            dataKey="id" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50]" sortField="settleDate" class="p-datatable-sm" stripedRows >

                                <template #header>
                                    <Toolbar>
                                        <template #start>
                                            <div class="custom-card-title">{{$t('SettleDetails.page_title')}} - {{selectedSettle.planningTrueUpFamilyPoolConfiguration}}</div>
                                        </template>

                                        <template #end>
                                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openDialogSettleDailyPrice" v-if="!uiPermissions('settleDailyPriceAddButton').isHidden"/>
                                        </template>
                                    </Toolbar>
                                </template>

                                <Column :rowEditor="true" style="width: 150px;" v-if="!uiPermissions('settleDailyPriceEditButton').isHidden" />

                                <Column field="settleDate" :header="$t('SettleDetails.settleDate')" >
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDate(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                                    </template>
                                    <template #editor="{ data, field }">
                                        <Calendar 
                                        class="w-full" 
                                        v-model="data[field]" 
                                        dateFormat="dd/mm/yy" 
                                        placeholder="dd/mm/yyyy"/> 
                                    </template>
                                </Column>
                                <Column field="settleValue" :header="$t('SettleDetails.settleValue')" >
                                    <template #body="{ data, field }">
                                        <span>{{data[field] != null ? utils.formatDecimal(data[field], 3) : null}}</span>
                                    </template>
                                    <template #editor="{ data, field }">
                                        <InputNumber class="w-full" :minFractionDigits="0" :maxFractionDigits="5" v-model="data[field]" />
                                    </template>
                                </Column>

                                <Column>
                                <template #body="slotProps">                        
                                    <Button icon="pi pi-trash" v-tooltip="$t('SettleDetails.deletesettleDailyPrice')" class="p-button-sm p-button-rounded p-button-outlined mr-1 mb-1" 
                                    size="small" @click="deleteSettleDailyPrice(slotProps.data.id)" v-if="!uiPermissions('settleDailyPriceDeleteButton').isHidden" />
                                </template>
                            </Column>

                            </DataTable>
                        </template>                          
                    </Card>
                </div>                            
            </div>
        </div>
    </main>
</template>

<style>
    .custom-card-title{
        font-size: medium;
    }
</style>
